import React from 'react'

export const Skeleton = () => {
  return (
    <div className='transition-all duration-200 cursor-pointer px-4 py-3 rounded-lg bg-gray-500 animate-pulse flex gap-2'>
      <div className='h-[18px] w-[18px] rounded-full bg-gray-400 mt-[2px] animate-pulse' />

      <div className='flex flex-col gap-4'>
        <p className='w-24 h-3 bg-gray-400/50 animate-pulse'></p>
        <p className='w-48 h-2 bg-gray-400/50 animate-pulse'></p>
      </div>
    </div>
  )
}
